var map = {
	"./asset.jpg": 22038,
	"./ceo.jpg": 13649,
	"./construction.jpg": 64815,
	"./contact.jpg": 31182,
	"./corporate.jpg": 30983,
	"./design.jpg": 59082,
	"./homebanner.jpg": 41191,
	"./image.png": 12125,
	"./invest.jpg": 39995,
	"./investment.jpg": 7687,
	"./leaders.jpeg": 8953,
	"./logo.jpg": 52717,
	"./logo.png": 62077,
	"./logol.png": 70309,
	"./map.jpeg": 6933,
	"./premises.jpg": 64296,
	"./project.jpg": 55465,
	"./services.jpg": 82208,
	"./sustainable.jpg": 58633,
	"./swiss.jpg": 70083,
	"./swiss2.webp": 99395,
	"./team.jpg": 72143,
	"./tree.jpeg": 7753,
	"./why.jpg": 85668,
	"./why.png": 36352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87958;